module.exports = __webpack_public_path__ + "static/petit-cafe-logo-628ef75170d3fbe8e7250637ebe2a833.svg";